import {call, fork, put, select, take} from "redux-saga/effects";

import {apiGet} from './callApi';
import actionTypes from "../actionTypes";
import {failCasinoTournamentNextInstance, successCasinoTournamentNextInstance} from "../actionCreators/gameBoxMission";

import {transformNextInstanceTemplate} from "./helpers/transform";

import {getSkinId, getToken, getTournamentGameBoxMission} from "../selectors";

import apiRoutes from "../../constants/apiRoutes";

function* getNextInstances(data: { templateId: number; tourInstanceId: number }): any {
  const tournamentMission = yield select(getTournamentGameBoxMission);
  const skinId = yield select(getSkinId);
  if (tournamentMission?.length) {
    try {
      const headers = {};
      headers['x-access-token'] = yield select(getToken);
      const params = {
        skinId: skinId,
        templateId: data?.templateId || tournamentMission[0]?.prize?.templateId,
        tourInstanceId: data?.tourInstanceId || tournamentMission[0]?.prize?.tourInstanceId
      };
      let response;
      if (data && data?.tourInstanceId && data?.templateId) {
        response = yield call(apiGet, 'REACT_APP_API_URL', apiRoutes.GET_CASINO_TOURNAMENT_INSTANCES, params, headers);
        response.data.result = response.data?.result[0];
      } else if (tournamentMission[0].status === 'completed' && tournamentMission[0]?.prize?.tourInstanceId) {
        response = yield call(apiGet, 'REACT_APP_API_URL', apiRoutes.GET_CASINO_TOURNAMENT_INSTANCES, params, headers);
        response.data.result = response.data.result[0];
      }
      if (response?.data?.result && response?.data?.success) {
        const transfromData = transformNextInstanceTemplate(response.data.result);
        yield put(successCasinoTournamentNextInstance(transfromData));
      } else {
        yield put(failCasinoTournamentNextInstance());
      }
    } catch (error) {
      yield put(failCasinoTournamentNextInstance(error));
    }
  }
}

export default function* watchCasinoTournamentInstancesRequest(): any {
  while (true) {
    const action = yield take([
      actionTypes.GAME_BOX_MISSION_SUCCESS,
      actionTypes.CASINO_TOURNAMENT_NEXT_INSTANCES]);
    yield fork(getNextInstances, action?.value?.tourInstanceId || action?.value);
  }
}